import WithRender from "../../templates/buttons/backToMatrixButton.html";
import { mapActions, mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getMatrixComplete"])
  },
  methods: {
    ...mapActions(["setMatrixComplete"]),

    onClickBack: function () {
      this.setMatrixComplete(!this.getMatrixComplete);
    }
  }
});
